import * as React from "react";
import { IClinician, ISearchParams } from "intake_shared/src/types";
import { Button } from "../../../bits/Button/Button";
import styles from "./ExpLevelSearchResult.module.scss";
import { cn } from "../../../../helpers";
import { isExperienceCredentialExpired } from "intake_shared/src/util";

interface ExpLevelSearchResultProps {
    clinicians: IClinician[];
    searchParams: ISearchParams;
    setSearchParams: React.Dispatch<React.SetStateAction<ISearchParams>>;
}

export default function ExpLevelSearchResult({
    clinicians,
    searchParams,
    setSearchParams,
}: ExpLevelSearchResultProps) {
    if (
        clinicians.length < 1 ||
        Object.keys(searchParams.experience_level).length < 1
    ) {
        return <></>;
    }

    const expLevelKeys = Object.keys(searchParams.experience_level);
    const cloudBtns: JSX.Element[] = [];
    expLevelKeys.forEach((expLevelLabel) => {
        if (!searchParams.experience_level[expLevelLabel]) {
            return;
        }
        const levelCount: { [key: string]: number } = {};
        clinicians.forEach((c) => {
            const experienceLevel = c.experience_levels[expLevelLabel];
            if (isExperienceCredentialExpired(experienceLevel)) {
                return;
            }
            const level = experienceLevel?.level || "";
            if (level && level !== "None") {
                levelCount[level] = (levelCount[level] || 0) + 1;
            }
        });
        Object.keys(levelCount).forEach((k) => {
            const expLevelfilter = { ...searchParams.experience_level_filter };
            const isSelected = expLevelfilter[expLevelLabel] === k;
            cloudBtns.push(
                <Button
                    className={cn(
                        styles.cloudButton,
                        isSelected && styles.cloudButtonSelected
                    )}
                    variant="normal"
                    onClick={() => {
                        if (isSelected) {
                            delete expLevelfilter[expLevelLabel];
                        } else {
                            expLevelfilter[expLevelLabel] = k;
                        }
                        setSearchParams({
                            ...searchParams,
                            experience_level_filter: expLevelfilter,
                        });
                    }}
                >{`${expLevelLabel} - ${k} (${levelCount[k]})`}</Button>
            );
        });
    });

    return <div className={styles.expLevelSearchWrapper}>{cloudBtns}</div>;
}
